module.exports = __webpack_public_path__ + "static/media/food-8.78d2150e.jpg";